var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meals-empty"},[_c('figure',[_c('svg-icon',{attrs:{"icon":"icon-no-meals"}})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.__("The patient did not upload any meals")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }